import { render, staticRenderFns } from "./TalentLayout.vue?vue&type=template&id=b50e599a&"
import script from "./TalentLayout.vue?vue&type=script&lang=js&"
export * from "./TalentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports